import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';

const HEADER_PRIMARY_NAV_TEST_ID = '@web/HeaderPrimaryNav';
const HeaderPrimaryNav = styled.nav.attrs(() => ({
  'data-test': HEADER_PRIMARY_NAV_TEST_ID,
  id: 'headerPrimary'
}))`
  display: flex;
  height: 60px;
  align-items: center;
  padding: 0 ${ndsTokens.space.generic.x3};
  position: relative;
  z-index: 1049;
  background: ${ndsTokens.colors.palette.red.default};

  @media (max-width: ${ndsTokens.breakpoints.smMax}) {
    ${({
  isStickySmallScreen
}) => isStickySmallScreen && `
      position: fixed;
      width: 100%;
    `}
  }

  @media (min-width: ${ndsTokens.breakpoints.md}) {
    height: 75px;
    padding: 0 ${ndsTokens.space.generic.x4} 0 ${ndsTokens.space.generic.x3};
  }
`;

export { HEADER_PRIMARY_NAV_TEST_ID, HeaderPrimaryNav };
